/**
 * Main ROB state.
 * Initializes manager and View
 * Handles and delegate import and export of ROB (Since robs are voyage bulk this is delegated to the BulkTankManager).
 */

var VRC = VRC || {};

VRC.RobState = (function () {

	var init = function () {
		VRC.RobManager.init();
		VRC.RobStateView.init();
	};

	var load = function () {
		VRC.BulkState.loadFromLocalStorage();
		init();
	};
	var save = function () {
		VRC.BulkState.saveToLocalStorage();
	};

	var fetch = function () {
		var deferred = $.Deferred();
		var loadContent = FetchData();

		loadContent.done(function () {
			load();
			deferred.resolve()
		});
		return deferred.promise();
	};

	var clear = function () {
		VRC.RobManager.deleteAll();
		save();
		init();
	};

	var menuSelect = function (p_select) {
		var SAVE_LOCALLY = 2;
		var LOAD_LOCALLY = 3;
		var DELETE_ALL = 5;
		var SUBMIT = 6;
		var FETCH = 8;

		if (p_select == SAVE_LOCALLY) {
			VRC.RobState.save();
			VRC.ErrorHandleService.showMessage('Data for ROB saved locally', G_MSG_TYPE_NORMAL);
		}
		else if (p_select == LOAD_LOCALLY) {
			VRC.RobState.load();
		}
		else if (p_select == DELETE_ALL) {
			var msg = 'This will remove all entries from list. Do you want to continue?';
			var onConfirm = function () {
				VRC.RobState.clear();
			};
			VRC.ConfirmationModal.show({msg: msg, onConfirm: onConfirm});
		}
		else if (p_select == SUBMIT) {
			OpenSubmitDialog();
		}
		else if (p_select == FETCH) {
			var msg = 'This will fetch last submitted data for Voyage Log, Bulk Tanks, ROB and Deck. Continue?';
			var onConfirm = function () {
				VRC.RobState.fetch();
			};
			VRC.ConfirmationModal.show({msg: msg, onConfirm: onConfirm});
		}
		else {
			console.error('Invalid menu object');
		}
	};

	return {
		init: init,
		save: save,
		load: load,
		clear: clear,
		fetch: fetch,
		menuSelect: menuSelect
	}
})();

